<template>
  <div id="Road">
    <div class="head">
      <div class="left">
        <span>连续出现</span>
        <Input @on-change="markContinuous" v-model="count" placeholder style="width: 60px" />
        <span>次以上</span>
        <Select v-model="select" style="width:60px">
          <Option v-for="(it,i) in data.labels" :value="it.key" :key="i">{{ it.name }}</Option>
        </Select>
        <Button type="primary" style="margin:0 5px" @click="markContinuous">确认</Button>
        <span>出现的次数为：{{selectRes}}</span>
      </div>
      <div class="right">
        <span>{{date}}累计:</span>
        <span v-for="(it,i) in statisRoad" :key="i">{{dataKeyName(i)}}({{it}})</span>
        <span class="red">{{getRankName()}}</span>
        <span class="red">{{data.name}}</span>
        <span class="red">最新</span>
        <span class="tobottom"></span>
      </div>
    </div>
    <div class="con">
      <ul ref="lists">
        <li
          v-for="(it,i) in reverseData"
          :key="i"
          :class="[`color${it[0]}`,{'mark':mark === it[0] && it.length >= count}]"
        >
          <p v-for="(is,j) in it">{{dataKeyName(is,j)}}</p>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: "Road",
  props: ["data", "rank", "road", "ranks", "roads", "date"],
  computed: {
    reverseData() {
      return this.data.arrs.reverse();
    },
    statisRoad() {
      return this.data.arrs.reduce((a, b) => {
        b.map(x => {
          if (!a[x]) {
            a[x] = 0;
          }
          a[x]++;
        });
        return a;
      }, {});
    }
  },
  data() {
    return {
      count: 1,
      select: this.data.labels[0].key,
      selectRes: 0,
      mark: ""
    };
  },
  methods: {
    dataKeyName(key) {
      // console.log("lables", this.data.labels);
      return this.data.labels.filter(x => x.key == key)[0].name;
    },
    getRankName() {
      return this.ranks.filter(x => x.key == this.rank)[0].name;
    },
    markContinuous() {
      this.mark = this.select;
      this.$nextTick(() => {
        let len = this.$refs.lists.getElementsByClassName("mark").length;
        this.selectRes = len;
      });
    }
  }
};
</script>
<style lang="less" scoped>
@media screen and (max-width: 1200px) {
  #Road {
    width: 100% !important;
    overflow-x: auto;
  }
}
#Road {
  width: 1140px;
  margin: 0 auto;
  margin-bottom: 20px;
  overflow-x: auto;
  .head {
    border: 1px solid #e6e6e6;
    background-color: #f5f5f5;
    height: 43px;
    font-size: 14px;
    color: #555;
    min-width: 1080px;
    span {
      margin: 0 5px;
    }
    .left {
      float: left;
      display: flex;
      align-items: center;
      height: 100%;
      padding-left: 10px;
    }
    .right {
      height: 100%;
      float: right;
      display: flex;
      align-items: center;
      .red {
        color: rgb(241, 2, 11);
      }
      .tobottom {
        width: 20px;
        height: 38px;
        padding: 0;
        background: url("../../../assets/img/bjpknum.png") no-repeat -257px -235px;
      }
    }
  }
  .con {
    min-width: 1080px;
    min-height: 130px;
    border: 1px solid #e6e6e6;
    border-top: 0;
    background: url("../../../assets/img/table_bg.png") repeat;
    ul {
      width: 100%;
      overflow: hidden;
      display: flex;
      justify-content: flex-end;
      overflow-x: auto;
    }
    li {
      flex: none;
      min-height: 130px;
      width: 30px;
      flex-shrink: 0;
      text-align: center;
      font-weight: normal;

      &:nth-last-child(2n) {
        background-color: #fff;
      }
      &:nth-last-child(2n-1) {
        background-color: #f5f5f5;
      }

      &:nth-last-child(1) p:nth-last-child(1) {
        font-weight: bold;
      }
      &.mark {
        background-color: rgb(253, 173, 86);
        color: #fff;
      }
      &.color1 {
        color: rgb(241, 2, 11);
        &.mark {
          color: rgb(241, 2, 11);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Trend/Luzhufenxi/Road.vue